<template>
	<MinMaxValue :index="index"></MinMaxValue>
</template>
<script type="text/javascript">
	import MinMaxValue from '../../componentsToQuestions/Min-Max-value.vue';

	export default {
		props: ['index'],
		components: { MinMaxValue },
	}
	
</script>